import React, { memo } from "react";
import styled from "styled-components";
import { Logo } from "./Logo";
import { LogoRR } from "./LogoRR";
import { moduleSettings } from "../../stores/module-settings.store";

interface IWrapperStyled {
  fontFamily: string;
}

interface IStyled {
  RREnabled: boolean;
}

const FooterWrapper = styled.div<IWrapperStyled>`
  font-family: ${(props) => props.fontFamily};
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 4px 20px;
  background-color: rgba(255, 255, 255, 0.8);

  @media screen and (max-width: 780px) {
    position: inherit;
  } ;
`;

const PowerBy = styled.div<IStyled>`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: end;
  color: #333333;

  span {
    margin-bottom: 4px;
  }

  @media screen and (max-width: 780px) {
    justify-content: ${(props) => (props.RREnabled ? "space-between" : "end")};
  } ;
`;

const FooterDef = () => {
  const RREnabled = moduleSettings.reservationResponsableEnabled;
  const fontFamily = moduleSettings.fontFamily;
  const poweredBy = (
    <PowerBy RREnabled={RREnabled}>
      {RREnabled && <LogoRR />}
      <Logo />
    </PowerBy>
  );

  return (
    <FooterWrapper data-test="footer" fontFamily={fontFamily}>
      {moduleSettings.settings.show_powered_by ? poweredBy : ""}
    </FooterWrapper>
  );
};
export const Footer = memo(FooterDef);
